// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-yRN","name":"styles_name__1603E","phone":"styles_phone__1PpWC"};